const MAX_DATA_LENGTH = 4000;
const FACT_KEYS = [
  ['appLabel', 'App'],
  ['actionLabel', 'Action'],
  ['connectionRef', 'Connection']
];
const NOT_INPUT_KEYS = new Set(['request', 'response', 'output', 'result', 'completed', 'userIntentLabel', ...FACT_KEYS.map(([key]) => key)]);

const toPrettyJson = (value) => {
  const text = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
  return text.length > MAX_DATA_LENGTH ? `${text.slice(0, MAX_DATA_LENGTH)}\n...` : text;
};

/**
 * What a step's detail shows: the app, action and connection it used, then its input (the
 * arguments that were set) and its result, as readable JSON cut at 4,000 characters.
 */
const toStepDetails = (args) => {
  const safeArgs = args && typeof args === 'object' ? args : {};
  const facts = FACT_KEYS.filter(([key]) => safeArgs[key]).map(([key, label]) => ({ label, value: String(safeArgs[key]) }));
  const inputEntries = Object.entries(safeArgs).filter(([key, value]) => !NOT_INPUT_KEYS.has(key) && value !== null && value !== undefined && value !== '');

  return {
    facts,
    input: inputEntries.length > 0 ? toPrettyJson(Object.fromEntries(inputEntries)) : '',
    result: safeArgs.result !== undefined && safeArgs.result !== null ? toPrettyJson(safeArgs.result) : ''
  };
};

export default toStepDetails;
